import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import CloseIcon from "assets/icons/close.svg?react";
import WindowsIcon from "assets/icons/windows.svg?react";
import MacIcon from "assets/icons/mac.svg?react";
import Button from "components/Button";
import { useTranslation } from "react-i18next";

const PluginUpdate: FC<Props> = ({
  handleClose,
}) => {
  const { t } = useTranslation();
  const downloadWindows = () => {
    const link = document.createElement("a");
    link.target = "__blank";
    link.href = "https://notaup.pl/plugin/wtyczkaNoty.msix";
    document.body.appendChild(link);
    link.click();

    setTimeout(() => {
      handleClose();
    }, 500);
  };

  return (
    <div className={styles.modal}>
      <div className={styles.window}>
        <div className={styles.wrapper}>
          <div className={styles.hdr}>
            <div>{t("plugin.updatePlugin")}</div>
            <CloseIcon onClick={handleClose} className={styles.closeIcon} />
          </div>
          <div className={styles.body}>
            {t("plugin.updateDescription")}
            <br></br>
            <br></br>
            {t("plugin.installAndRun")}
          </div>

          <div className={styles.system}>
            <Button
              element={
                <div className={styles.buttonContent}>
                  <WindowsIcon className={styles.icon} />
                  Windows
                </div>
              }
              onClick={downloadWindows}
            ></Button>
            <Button
              element={
                <div className={styles.buttonContent}>
                  <MacIcon className={styles.icon} />
                  MacOS
                </div>
              }
              onClick={() => {}}
              disabled={true}
            ></Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PluginUpdate;
